/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crown_The_CoverInputs */

const en_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crown the Cover`)
};

const es_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coronar la Portada`)
};

const fr_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couronner la Couverture`)
};

const de_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krönen Sie das Cover`)
};

const ja_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表紙を飾る`)
};

const zh_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`封面加冕`)
};

const ar_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتويج الغلاف`)
};

const id_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahkotai Sampulnya`)
};

const it_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorona la Copertina`)
};

const ru_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Украсить Обложку`)
};

const pt_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coroar a Capa`)
};

const ko_crown_the_cover = /** @type {(inputs: Crown_The_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표지 장식하기`)
};

/**
* | output |
* | --- |
* | "Crown the Cover" |
*
* @param {Crown_The_CoverInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const crown_the_cover = /** @type {((inputs?: Crown_The_CoverInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crown_The_CoverInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crown_the_cover(inputs)
	if (locale === "es") return es_crown_the_cover(inputs)
	if (locale === "fr") return fr_crown_the_cover(inputs)
	if (locale === "de") return de_crown_the_cover(inputs)
	if (locale === "ja") return ja_crown_the_cover(inputs)
	if (locale === "zh") return zh_crown_the_cover(inputs)
	if (locale === "ar") return ar_crown_the_cover(inputs)
	if (locale === "id") return id_crown_the_cover(inputs)
	if (locale === "it") return it_crown_the_cover(inputs)
	if (locale === "ru") return ru_crown_the_cover(inputs)
	if (locale === "pt") return pt_crown_the_cover(inputs)
	return ko_crown_the_cover(inputs)
});